import { Link, useNavigate } from "react-router-dom";

export function SiteHeader() {
  const navigate = useNavigate();

  return (
    <nav className="sticky top-0 z-50 bg-surface-950/95 backdrop-blur-xl border-b border-surface-800/50 shadow-lg">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16 sm:h-20">
          {/* Logo */}
          <Link to="/" className="flex items-center gap-3 no-underline">
            <img src="/logo.svg" alt="TradeCraft" className="w-10 h-10" />
            <div className="hidden sm:block">
              <span className="text-xl font-bold bg-gradient-to-r from-primary-400 to-accent-400 bg-clip-text text-transparent">
                TradeCraft
              </span>
              <p className="text-xs text-surface-500">by Colvix</p>
            </div>
          </Link>

          {/* Nav Links */}
          <div className="hidden md:flex items-center gap-8">
            <Link to="/" className="text-surface-300 hover:text-primary-400 transition-colors text-sm">Home</Link>
            <Link to="/search" className="text-surface-300 hover:text-primary-400 transition-colors text-sm">Community</Link>
            <Link to="/faq" className="text-surface-300 hover:text-primary-400 transition-colors text-sm">FAQ</Link>
          </div>

          {/* CTA Buttons */}
          <div className="flex items-center gap-3">
            <button
              onClick={() => navigate("/login")}
              className="px-4 py-2 text-sm font-medium text-surface-300 hover:text-surface-100 transition-colors"
            >
              Sign In
            </button>
            <button
              onClick={() => navigate("/signup")}
              className="px-5 py-2.5 text-sm font-semibold rounded-lg bg-gradient-to-r from-primary-500 to-accent-500 text-white hover:shadow-lg hover:shadow-primary-500/30 transition-all duration-300 hover:-translate-y-0.5"
            >
              Get Started Free
            </button>
          </div>
        </div>
      </div>
    </nav>
  );
}
